export const oldManLines = {
  world: {
    lines: [
      { speaker: "Old Man", text: "Waves once kissed my boat,\nHer laugh once danced on the wind—\nBoth have since gone home." },
      { speaker: "Randy", text: "Boats rock me to sleep,\nWind once danced with my boxers—\nNeighbors filed a claim." },

      { speaker: "Old Man", text: "She brewed morning tea,\nBirds came knowing her warm hands—\nKindness lingered there." },
      { speaker: "Randy", text: "I made ramen once.\nBirds came, but it was seagulls—\nStill counts as magic." },

      { speaker: "Old Man", text: "Many walked too fast,\nPebbles unturned in their haste—\nYou stayed. That meant much." },
      { speaker: "Randy", text: "I stay for snacks, yes.\nAnd for vibes. And ghost lanterns—\nMostly 'cause I’m lost." },

      { speaker: "Old Man", text: "One heart fed the sea,\nOne heart fed sparrows with joy—\nThis one, I kept back." },
      { speaker: "Randy", text: "Sparrows pecked my fries.\nI fed them rage and ketchup—\nThey respected me." },

      { speaker: "Old Man", text: "Lanterns once burned bright,\nGuiding souls through winter fog—\nStill, I wait beside the shore." },
      { speaker: "Randy", text: "I burned a lantern.\nAccidentally. Then left.\nStill—vibes were restored." }
    ],
    voices: [
      "oldman_world1",
      "oldman_world2",
      "oldman_world3",
      "oldman_world4",
      "oldman_world5"
    ],
    randyVoices: [
      "randy_oldman1",
      "randy_oldman2",
      "randy_oldman3",
      "randy_oldman4",
      "randy_oldman5"
    ]
  },

  bath: {
    lines: [
      { speaker: "Old Man", text: "Steam fogs memory—\nmy bones remember the war,\nmy heart forgets it." },
      { speaker: "Randy", text: "Steam fogs my glasses.\nI declare war on shampoo—\nIt always wins, though." },

      { speaker: "Old Man", text: "Silence like warm rain\nmelts the armor of old grief.\nThe tub overflows." },
      { speaker: "Randy", text: "Tub is full of peace,\nand one questionable sock—\nI claim both as mine." },

      { speaker: "Old Man", text: "The boy once ran here—\nsoap bubbles caught in his hair,\nlaughing like the wind." },
      { speaker: "Randy", text: "I slipped on a bar.\nLaughed like wind and hit the tiles—\nSpa day: completed." }
    ],
    voices: [
      "oldman_bath1",
      "oldman_bath2",
      "oldman_bath3"
    ],
    randyVoices: [
      "randy_oldmanbath1",
      "randy_oldmanbath2",
      "randy_oldmanbath3"
    ]
  }
};

export const voiceLinesMap = {
  world: [
    "oldman_world1",
    "oldman_world2",
    "oldman_world3",
    "oldman_world4",
    "oldman_world5"
  ],
  bath: [
    "oldman_bath1",
    "oldman_bath2",
    "oldman_bath3"
  ]
};

export default oldManLines;
